import { action } from 'satcheljs/lib/legacy';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getCalendarPath, getOwaUrlWithAddedQueryParameters } from 'owa-url';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
var showCalendar = action('showCalendar')(function showCalendar(newWindow) {
    var userOptions = getUserConfiguration().UserOptions;
    // switch to calendar module
    var calendarUrl = isControlFeatureEnabled('cal-react') ||
        (userOptions &&
            userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.CalendarEnabled)
        ? getHostLocation()
            .href.replace(getHostLocation().hash, '')
            .replace(getHostLocation().pathname, getCalendarPath())
        : getOwaUrlWithAddedQueryParameters({ path: '/calendar' });
    newWindow.open(calendarUrl, '_self');
    return Promise.resolve();
});
export default showCalendar;
//# sourceMappingURL=showCalendar.js.map